module.exports = __webpack_public_path__ + "img/Michael Herbig.3480f659.jpg";